import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";

const useScanBarcodeAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const isWaiter = useIsWaiter();

  return {
    name: "scanBarcode" as CurrentActionTypes,
    label: t("posOrders.scanBarcode"),
    set: () => document.getElementById("barcode")?.focus(),
    instantSet: true,
    filtered: false /* !isWaiter */,
    disabled: false,
    iconVariant:"barcode",
  };
};

const ScanBarcodeAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useScanBarcodeAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default ScanBarcodeAction;
